import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const LSCOFIN_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/lscofin/logo.png",
        alt: "LifeSolutions Counseling Associates Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 46,
  state: "IN",
  departmentIds: [208, 225, 235, 493, 507, 515, 528],
};
